export const fonts = {
	heading: "Inter, sans-serif",
	body: "Inter, sans-serif",
}
